import React, { useState, useEffect } from 'react'

import { Helmet } from 'react-helmet-async'
import axios from 'axios'
import Select from 'react-select'

import { useAuth } from 'src/hooks/AuthProvider'
import WidthLimiter from '../../containers/width-limiter/width-limiter'
import Button from '../../components/parts/button/button'
import styles from '../../styles/stat-page/stat-page.module.scss'
import { alertError } from '../../utils/alert'
import { TOption } from '../../constants/types'
import { API_URL } from '../../constants'
import { FieldMaterialType } from '../../constants/input-data'
import { toast, ToastContainer } from 'react-toastify'

const ViewsChange = () => {
  const { userData } = useAuth()

  const [data, setData] = useState({
    specs: [] as TOption[]
  })

  const [selectedSpecs, setSelectedSpecs] = useState<TOption | null>(null)
  const [selectedMaterialType, setSelectedMaterialType] = useState<TOption | null>(null)
  const [materialId, setMaterialId] = useState(0)
  const [count, setCount] = useState(0)
  const [duration, setDuration] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (name: 'specs' | 'materialType') => (selected: any) => {
    if (name === 'specs') setSelectedSpecs(selected)
    if (name === 'materialType') setSelectedMaterialType(selected)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    if (name === 'materialId') setMaterialId(Number(value))
    if (name === 'count') setCount(Number(value))
    if (name === 'duration') setDuration(Number(value))
  }

  useEffect(() => {
    const fetchAllData = async () => {
      const [specsResponse] = await Promise.all([axios.get(`${API_URL}/api/list/specialities`)])

      if (specsResponse.status === 200) {
        setData((prev) => ({
          ...prev,
          specs: specsResponse.data
        }))
      } else {
        toast('Something went wrong :(')
      }
    }

    fetchAllData()
  }, [])

  const postStat = async () => {
    try {
      if (isLoading) return
      setIsLoading(true)

      const body = {
        specId: selectedSpecs?.value,
        materialType: selectedMaterialType?.value,
        materialId,
        count,
        duration
      }

      const response = await axios.post(`${API_URL}/api/views`, body)

      if (response.status === 200) {
        toast('Просмотры успешно добавлены')
        setSelectedSpecs({ value: '', label: '' })
        setSelectedMaterialType({ value: '', label: '' })
        setMaterialId(0)
        setCount(0)
        setDuration(0)
      }
    } catch (err: any) {
      const errMesage = `${err.response?.data?.error} ${err.response?.data?.message}`
      alertError(errMesage)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (!userData?.isHasAccess) return
  }, [userData])

  return (
    <>
      <Helmet>
        <title>Обновление просмотров</title>
      </Helmet>
      <WidthLimiter>
        <div>
          <div className={styles.subheader}>специальность: </div>
          <Select
            placeholder="Выберите специальность"
            options={data.specs}
            isMulti={false}
            closeMenuOnSelect={false}
            value={selectedSpecs}
            onChange={handleChange('specs')}
          />
        </div>
        <div>
          <div className={styles.subheader}>тип материала: </div>
          <Select
            placeholder="Выберите тип материала"
            options={FieldMaterialType}
            isMulti={false}
            closeMenuOnSelect={false}
            value={selectedMaterialType}
            onChange={handleChange('materialType')}
          />
        </div>
        <div>
          <div className={styles.subheader}>id материала: </div>
          <input
            type="text"
            name="materialId"
            onChange={handleInputChange}
            placeholder="Id"
            className={styles.input}
            inputMode="numeric"
            value={materialId}
          />
        </div>
        <div>
          <div className={styles.subheader}>просмотры: </div>
          <input
            type="text"
            name="count"
            onChange={handleInputChange}
            placeholder="Count"
            className={styles.input}
            inputMode="numeric"
            value={count}
          />
        </div>
        <div>
          <div className={styles.subheader}>длительность, мин.: </div>
          <input
            type="text"
            name="duration"
            onChange={handleInputChange}
            placeholder="Duration"
            className={styles.input}
            inputMode="numeric"
            value={duration}
          />
        </div>
        <Button
          modificator={styles.btnMargin}
          disabled={isLoading || !selectedSpecs?.value || !selectedMaterialType?.value || !materialId || !count}
          onClick={postStat}
        >
          Прибавить!
        </Button>
        <ToastContainer />
      </WidthLimiter>
    </>
  )
}

export default ViewsChange
